import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./TrackingNoResult.module.css";
import useHelpers from "@hooks/useHelpers";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
var TrackingNoResult = function TrackingNoResult() {
  var _useTranslation = useTranslation(["web_tracking", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/syarah_no_orders.svg",
    alt: "img"
  }), /*#__PURE__*/React.createElement("strong", null, t("don_t_orders", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", null, t("browse_cars", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    className: stl.btn,
    onClick: function onClick() {
      return navigateTo("/filters");
    }
  }, t("browse_cars_2", {
    ns: "web_tracking"
  })));
};
export default TrackingNoResult;